import { IProgressStep, ProgressValues } from '@pc/progress-step-indicator';
import { RouterPaths } from './shared/models/router-model';

export const ROUTER_PATHS: RouterPaths = {
  COVER_OPTIONS: 'cover-options',
  SECURE_CHECKOUT: 'secure-checkout',
  TRAVELER_DETAILS: 'traveler-details',
  TRIP_DETAILS: 'trip-details',
  SUCCESS_PAGE: 'success-page',
  BILLING_SUCCESS: 'billing/payment-success',
  BILLING_ERROR: 'billing/payment-error',
  UNDER_CONSTRUCTION: 'under-construction',
  GATEWAY: 'select-product'
};

export const QUERY_PARAMS = { SUB_STEP: 'subStep' };

export const ProgressStepNames = {
  TripDetails: 'Trip Details',
  CoverageSelection: 'Cover Options',
  TravelersDetails: 'Traveller Details',
  SecureCheckout: 'Secure Checkout'
};

export const StepsRoutes = {
  TripDetails: '/trip-details',
  CoverageSelection: '/cover-options',
  TravelersDetails: '/traveler-details',
  SecureCheckout: '/secure-checkout'
};

export const CompleteProgressStepsDesktop: IProgressStep[] = [
  {
    name: ProgressStepNames.TripDetails,
    route: StepsRoutes.TripDetails,
    isCompleted: false,
    progress: ProgressValues.Ten,
    isCustomStep: false
  },
  {
    name: ProgressStepNames.CoverageSelection,
    route: StepsRoutes.CoverageSelection,
    isCompleted: false,
    progress: ProgressValues.Ten,
    isCustomStep: false
  },
  {
    name: ProgressStepNames.TravelersDetails,
    route: StepsRoutes.TravelersDetails,
    isCompleted: false,
    progress: ProgressValues.Ten,
    isCustomStep: false
  },
  {
    name: ProgressStepNames.SecureCheckout,
    route: StepsRoutes.SecureCheckout,
    isCompleted: false,
    progress: ProgressValues.Ten,
    isCustomStep: false
  }
];

export const CompleteProgressStepsMobile: IProgressStep[] = [
  {
    name: ProgressStepNames.TripDetails,
    route: StepsRoutes.TripDetails,
    isCompleted: false,
    progress: ProgressValues.Ten,
    isCustomStep: false
  },
  {
    name: ProgressStepNames.CoverageSelection,
    route: StepsRoutes.CoverageSelection,
    isCompleted: false,
    progress: ProgressValues.Ten,
    isCustomStep: false
  },
  {
    name: ProgressStepNames.TravelersDetails,
    route: StepsRoutes.TravelersDetails,
    isCompleted: false,
    progress: ProgressValues.Ten,
    isCustomStep: false
  },
  {
    name: ProgressStepNames.SecureCheckout,
    route: StepsRoutes.SecureCheckout,
    isCompleted: false,
    progress: ProgressValues.Ten,
    isCustomStep: false
  }
];

export const WhoSectionConfig = {
  minAdultAge: 18,
  maxTravelerAmount: 8,
  maxChildrenAmount: 7,
  maxAdultAmount: 2,
  maxPurchasableAge: 85,
  maxDependentAge: 24,
  minDependentAge: 18,
  maxAdultAge: 120,
  minChildrenAge: 0
};

export enum ApiPaths {
  Quote = 'Quote',
  Proposal = 'Proposal',
  Policy = 'Policy',
  GetDetails = 'getDetails',
  SalesExperiments = 'SetSalesExperiments',
  ValidateAgentCC = 'ValidateAgentCC',
  Agent = 'Agent',
  IsAgentAgreementActive = 'isAgentAgreementActive',
  Organization = 'Organization',
  QuoteDetails = 'QuoteDetails',
  BenefitsCheckPolicy = 'policy/checkPolicy',
  BenefitsUpdate3rdPartyMailing = 'user/update3rdPartyMailing',
  Collinson = 'Collinson',
  CollinsonOtpIdentification = 'CollinsonOtpIdentification',
  GetQuoteDetails = 'Quote/GetQuoteDetails',
  SaveBasicQuoteDetails = 'Quote/SaveBasicQuoteDetails',
  GetBasicQuoteDetails = 'Quote/GetBasicQuoteDetails'
}

export const ABTestingVariants = {
  CreditCard: 'credit card variant',
  Wallet: 'wallet variant'
};
